import { spinner } from "../Views/Shared.js";
import { view as view_1, resetPasswordView, forgotPasswordView } from "../Views/Login.js";
import { view as view_2 } from "../Views/Account.js";
import { view as view_3 } from "../Views/Contact.js";
import { view as view_4 } from "../Views/EventList.js";
import { view as view_5 } from "../Views/EventOverview.js";
import { createElement } from "react";
import React from "react";
import { uncurry2, createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { init as init_1, t } from "../Lang.js";
import { App_goToDashboard, App_notFound } from "../Shared/Tr.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { currentPage } from "../Router.js";
import { Msg } from "./Messages.js";
import { mainLayout } from "../Views/Layout.js";
import { ProgramModule_mkProgram, ProgramModule_run } from "../fable_modules/Fable.Elmish.4.4.0/program.fs.js";
import { Program_withReactSynchronous } from "../fable_modules/Fable.Elmish.React.4.0.0/react.fs.js";
import { update, init } from "../App.js";

function pageContent(model, dispatch) {
    let elems_1, elems;
    if (model.IsLoading) {
        return spinner();
    }
    else {
        const matchValue_1 = model.CurrentPage;
        switch (matchValue_1.tag) {
            case 1:
                return forgotPasswordView(model, dispatch);
            case 2:
                return resetPasswordView(model, dispatch);
            case 3:
                if (model.CurrentUser == null) {
                    return view_1(model, dispatch);
                }
                else {
                    return view_2(model, dispatch);
                }
            case 4:
                return view_3(model, dispatch);
            case 5:
                if (model.CurrentUser == null) {
                    return view_1(model, dispatch);
                }
                else {
                    return view_4(model, dispatch);
                }
            case 6:
                if (model.CurrentUser == null) {
                    return view_1(model, dispatch);
                }
                else {
                    return view_5(model, matchValue_1.fields[0], matchValue_1.fields[1], dispatch);
                }
            case 7:
                return createElement("div", createObj(ofArray([["className", "auth-container"], (elems_1 = [createElement("div", createObj(ofArray([["className", "card"], (elems = [createElement("h2", {
                    children: t(App_notFound),
                }), createElement("a", {
                    href: "#/",
                    children: t(App_goToDashboard),
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
            default:
                return view_1(model, dispatch);
        }
    }
}

export function AppView(appViewInputProps) {
    const dispatch = appViewInputProps.dispatch;
    const model = appViewInputProps.model;
    useEffectWithDeps(() => {
        const handler = (_arg) => {
            dispatch(new Msg(1, [currentPage()]));
        };
        window.addEventListener('hashchange', handler);
        return {
            Dispose() {
                window.removeEventListener('hashchange', handler);
            },
        };
    }, []);
    return mainLayout(model.CurrentUser, model.HelpPanel, model.Toasts, dispatch, pageContent(model, dispatch));
}

export function view(model, dispatch) {
    return createElement(AppView, {
        model: model,
        dispatch: dispatch,
    });
}

function startElmish() {
    ProgramModule_run(Program_withReactSynchronous("app", ProgramModule_mkProgram(init, uncurry2(update), view)));
}

function initAndStart(json) {
    init_1(json);
    startElmish();
}

const langCode = (() => {
    const raw = localStorage.getItem('lang') || navigator.language || 'en';
    return (raw.length >= 2) ? raw.slice(0, 1 + 1) : "en";
})();

fetch('/lang/' + langCode + '.json', {cache:'no-cache'})
       .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
       .catch(function() {
           return fetch('/lang/en.json', {cache:'no-cache'})
               .then(function(r) { return r.json(); })
               .catch(function() { return {}; });
       })
       .then((json) => {
    initAndStart(json);
});

